import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AdminService } from 'src/app/business-service/admin/admin.service';
import { PayuPaymentService } from '../shared/services/payu-payment.service';
import { AdduserCostComponent } from './adduser-cost/adduser-cost.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';


@Component({
  selector: 'app-payment-management',
  templateUrl: './payment-management.component.html',
  styleUrls: ['./payment-management.component.scss'],
})
export class PaymentManagementComponent implements OnInit {
  @ViewChild(AdduserCostComponent) addUserCostComponent!: AdduserCostComponent;
  @ViewChild(PaymentDetailsComponent) paymentDetailsComponent!: PaymentDetailsComponent;

  currentStep = 1;
  selectedPackageData: any;
  usersAndCostData: any;
  billingDetails: any;

  txnId: any;

  isTrailUser: boolean = true;
  existingPackageDetails: any;

  pendingPaymentTransaction: any;

  constructor(
    private _modalControl: ModalController,
    private _adminService: AdminService,
    private _paymentService: PayuPaymentService
  ) { }

  async ngOnInit() {
    this.pendingPaymentTransaction = await this.getPendingPayuTransaction();
    this.pendingPaymentTransaction = this.pendingPaymentTransaction[0];

    if (this.pendingPaymentTransaction) {
      await this.updateDataBasedOnPendingTransaction(this.pendingPaymentTransaction);
      if (this.selectedPackageData) {
        this.currentStep = 1;
      }
      if (this.usersAndCostData) {
        this.currentStep = 2;
      }
      if (this.billingDetails) {
        this.currentStep = 3;
      }
    }

    let orgData = await this.getOrganzationDetails(localStorage.getItem("CId"));
    const existingPackageId = orgData?.organizationDetails?.packageId;

    if (Array.isArray(existingPackageId) && existingPackageId.length && !existingPackageId.includes("PACK1000")) {
      this.isTrailUser = false;
      const index = existingPackageId.indexOf("PACK1006");
      if (index > -1) {
        existingPackageId.splice(index, 1);
      }

      this.existingPackageDetails = await this.getPackageDetails(existingPackageId[0]);
      this.selectedPackageData = this.existingPackageDetails;
      this.currentStep = 1;
    }

    if (this.txnId) {
      this.currentStep = 4;
    }
  }

  async getOrganzationDetails(orgId: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._adminService.getOrganization(orgId).subscribe({
        next: (data) => {
          resolve(data);
        }
      })
    })
  }

  async getPackageDetails(orgId: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._adminService.getPackageDetails(orgId).subscribe({
        next: (data) => {
          resolve(data);
        }
      })
    })
  }

  async getPendingPayuTransaction(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let orgId = localStorage.getItem("CId");
      this._paymentService.getPendingPayUTransaction(orgId).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (err) => {
          console.error('Error fetching pending PayU transaction:', err);
          reject(err);
        }
      });
    });
  }

  async updateDataBasedOnPendingTransaction(pendingTransaction: any) {
    if (pendingTransaction) {
      if (Array.isArray(pendingTransaction.packageId) && pendingTransaction.packageId?.length) {
        const index = pendingTransaction.packageId.indexOf("PACK1006");
        if (index > -1) {
          pendingTransaction.packageId.splice(index, 1);
        }
        this.selectedPackageData = await this.getPackageDetails(pendingTransaction.packageId[0]);
      }
      if (pendingTransaction.totalLicense) {
        this.usersAndCostData = {
          baseAmount: pendingTransaction.amount,
          totalAmount: pendingTransaction.totalAmount,
          noOfUsers: pendingTransaction.totalLicense,
          selectedPlan: pendingTransaction.totalLicense > 0 ? 'perUser' : 'unlimited',
          taxes: pendingTransaction.taxes || []
        }
      }
      if (pendingTransaction.billingName) {
        this.billingDetails = pendingTransaction;
      }
      this.reloadAllChildComponents();
    }
  }

  // Move to next or specific step
  goToStep(step: number) {
    this.currentStep = step;
  }

  // When package is selected
  handlePackageSubmit(packageData: any) {
    this.selectedPackageData = packageData;
    this.goToStep(2);
  }

  saveAmountData(data: any) {
    this.usersAndCostData = data;
  }

  saveBillingData(data: any) {
    this.billingDetails = data;
  }

  // When "Proceed" is clicked in Add User
  handleProceedFromAddUser() {
    this.goToStep(3);
  }


  handlePaymentComplete() {
    this.goToStep(4);
  }
  // go back to previous step
  goBack() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }


  handleFinishStep() {
    this.closeModal();
  }

  closeModal() {
    this._modalControl.dismiss();
  }

  serializeData(): any {
    this.usersAndCostData?.taxes.forEach((element: any) => {
      element.amount = parseFloat(element.amount.toFixed(2))
    });
    const serializedData:any = {
      billingName: this.billingDetails?.billingName || null,
      phoneNumber: this.billingDetails?.phoneNumber || null,
      email: this.billingDetails?.email || null,
      gstin: this.billingDetails?.gstin || null,
      country: this.billingDetails?.country || null,
      state: this.billingDetails?.state || null,
      city: this.billingDetails?.city || null,
      zipCode: this.billingDetails?.zipCode || null,
      isRegisteredForGSTIN: this.billingDetails?.isRegisteredForGSTIN || null,

      // packageDetails
      packageId: [this.selectedPackageData?.packageId],
      productInfo: this.selectedPackageData?.packageName || null,

      // Right-side form controls
      totalLicense: this.usersAndCostData?.noOfUsers || null,
      amount: parseFloat(this.usersAndCostData?.baseAmount.toFixed(2)) || null,
      totalAmount: parseFloat(this.usersAndCostData?.totalAmount.toFixed(2)) || null,
      taxes: this.usersAndCostData?.taxes || null,

      txnId: this.pendingPaymentTransaction?.txnId || null,
      id: this.pendingPaymentTransaction?.id || null,
      organizationId: this.pendingPaymentTransaction?.organizationId || null,
      createDate: this.pendingPaymentTransaction?.createDate || null,
      createdBy: this.pendingPaymentTransaction?.createdBy || null,
    }
    return serializedData
  }

  async createPayUPaymentRequest(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._paymentService.createPayUPayment(this.serializeData(), true).subscribe({
        next: (response: any) => {
          document.open();
          document.write(response);
          document.close();
          resolve(response);
        },
        error: (error) => {
          reject(error);
          console.error('API call failed:', error);
        }
      });
    });
  }

  async storePaymentData(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._paymentService.addOrUpdatePayUPayment(this.serializeData()).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error) => {
          reject(error);
          console.error('API call failed:', error);
        }
      });
    });
  }

  async updateBillingDetails(isPayuPaymentRequried: any) {
    if (isPayuPaymentRequried) {
      await this.createPayUPaymentRequest();
    }
    else {
      this.pendingPaymentTransaction = await this.storePaymentData();
      await this.updateDataBasedOnPendingTransaction(this.pendingPaymentTransaction);
    }
  }

  reloadAllChildComponents() {
    if (this.addUserCostComponent) {
      this.addUserCostComponent.ngOnInit();
    }
    if (this.paymentDetailsComponent) {
      this.paymentDetailsComponent.ngOnInit();
    }
  }
}
